import { getSchema, MergeField, MergeSchema } from '../../decorators';
import { ActivityEntityName, Contact } from '../../../../entities';

@MergeSchema({
    entity: ActivityEntityName.Contact,
    name: 'ContactMergeSchema'
})
export class ContactMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    name: string;

    @MergeField()
    phone: string;

    @MergeField()
    mobile: string;

    @MergeField()
    email: string;

}

export const ContactMergeSchema = getSchema(ContactMergeData);

export const transformContactToMergeData = (contact: Contact): ContactMergeData => {
    if (!contact) {
        return {
            _id: null,
            name: null,
            phone: null,
            mobile: null,
            email: null,
        } as ContactMergeData;
    };

    return {
        _id: contact._id,
        name: contact.name,
        phone: contact.phone,
        mobile: contact.mobile,
        email: contact.email,
    } as ContactMergeData;
}